import React, { Fragment } from "react";
import axios from 'axios';
import Stepper from "../shared/stepper.js";
import ModalBoxModifica from "../shared/modal_modifica";
import ModalError from "../shared/modal_errore.js";
import Spinner from "../shared/spinner.js";
import ToggleContainer from "../shared/toggle_container.js";
import { handleFaFunnel, trackCF } from "../../modules/datalayer";
import utils from "../../modules/utils.js";
import {
  setFiliale,
  setProductFromParams,
  setOrario,
  setGiorno,
  setDove,
  setProdotto,
  setFlussoModifica,
  setRecap,
  setVecchioAppuntamento,
  setConsensi,
  setDatiPersonali,
  setCF,
  setOppID,
  setSource,
  setModificando,
  clearHistoryBack,
  setFoundDbCompass,
  setFirstLoad,
  setFaFunnerTriggered,
  start,
  setFlowSwitch,
  setRicontattoCf,
  setFiliali
} from "../../actions/index";
import { connect } from "react-redux";
import RecapArea from "../shared/recap_area.js";
/*import RecapBoxContainer from '../shared/recap_container.js'
import axios from 'axios';*/
import "./codice_fiscale.css";
import { trackPageView, startDigitalAssistant, trackRedirection } from "../../modules/datalayer.js";
import apiInvoker from "../../modules/apiInvoker.js";
/* Flow */
import { handleFlow, skipScegliLuogo, skipDataAppuntamento, goToHomepage, switchToPrestitoPersonale } from '../../flow/flow';
/* Mock */
import { userRiconosciutoByCF as mockedUserRiconosciuto } from '../../modules/mocks/user';

const mapDispatchToProps = dispatch => {
  return {
    setCF: cf => dispatch(setCF(cf)),
    setDatiPersonali: dati => dispatch(setDatiPersonali(dati)),
    setConsensi: consensi => dispatch(setConsensi(consensi)),
    setRecap: r => dispatch(setRecap(r)),
    setVecchioAppuntamento: v => dispatch(setVecchioAppuntamento(v)),
    setOppID: o => dispatch(setOppID(o)),
    setFlussoModifica: fl => dispatch(setFlussoModifica(fl)),
    setProdotto: p => dispatch(setProdotto(p)),
    setDove: d => dispatch(setDove(d)),
    setGiorno: g => dispatch(setGiorno(g)),
    setOrario: or => dispatch(setOrario(or)),
    setFiliale: f => dispatch(setFiliale(f)),
    setModificando: m => dispatch(setModificando(m)),
    setSource: source => dispatch(setSource(source)),
    clearHistoryBack: c => dispatch(clearHistoryBack(c)),
    setProductFromParams: pp => dispatch(setProductFromParams(pp)),
    setFoundDbCompass: dbc => dispatch(setFoundDbCompass(dbc)),
    setFirstLoad: (t) => dispatch(setFirstLoad(t)),
    setFaFunnerTriggered: (boolean) => dispatch(setFaFunnerTriggered(boolean)),
    start: (st) => dispatch(start(st)),
    setFlowSwitch: (payload) => dispatch(setFlowSwitch(payload)),
    setRicontattoCf: (payload) => dispatch(setRicontattoCf(payload)),
    setFiliali: (payload) => dispatch(setFiliali(payload)),
  };
};

const mapStateToProps = (state) => {
  return {
    excluded: state.cap_excluded,
    prodotto: state.prodotto,
    faFunnelTriggered: state.GTMEvents.faFunnelTriggered,
  }
}

class CodiceFiscale extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      errors: "",
      correct_submit: false,
      popup_open: false,
      appuntamento_recuperato: null,
      loading: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.editAppointment = this.editAppointment.bind(this);
    this.handleModifica = this.handleModifica.bind(this);
    this.handleAnnulla = this.handleAnnulla.bind(this);
    this.processCfInfo = this.processCfInfo.bind(this);
    this.triggerFaFunnelEvent = this.triggerFaFunnelEvent.bind(this);
    this.getFiliali = this.getFiliali.bind(this);
  }

  componentDidMount() {

    let prodotto_impostato = utils.getUrlParameter("prodotto");
    if (window.document.location.hostname.indexOf("compassquinto") != -1) {
      prodotto_impostato = 3;
    }
    /*
     * 2019-12-06 Nic richiede che il tracciamento venga passato in ogni caso, anche se la pagina è compassquinto o con prodotto impostato da parametro
     */
    this.props.setFirstLoad();
    startDigitalAssistant(); //2023-01-30 Riabilitiamo per questa pagina il DA
    //stopDigitalAssistant(); //Abbiamo superato il scegli luogo, non deve più apparire il DA

    if (
      window.document.location.hostname.indexOf("compassquinto.it") == -1 &&
      (prodotto_impostato != 3 && prodotto_impostato != 5)
    ) {
      //se non siamo su compass quinto, facciamo una pageview virtuale
      //trackPageView('codice-fiscale');
      if (!this.props.faFunnelTriggered) {
        this.triggerFaFunnelEvent(parseInt(prodotto_impostato));
        this.props.setFaFunnerTriggered(true);
      }
    } else if (prodotto_impostato == 3 || prodotto_impostato == 5) {
      //Andiamo ad impostare i parametri minimi per mantenere la pagina nel caso abbiano comunicato l'URL sbagliata
      this.props.setProductFromParams(true);
      this.props.setProdotto(prodotto_impostato);

      if (!this.props.faFunnelTriggered) {
        this.triggerFaFunnelEvent(parseInt(prodotto_impostato));
        this.props.setFaFunnerTriggered(true);
      }
    }

    trackPageView("codice-fiscale");

    // Check "source" parameter
    const global_state = utils.getState();

    if (!global_state.source) {
      const source = utils.getUrlParameter('source');

      if (source) {
        this.props.setSource(source);
      }
    }

    utils.animate.slideIn(utils.getState().dati_locali.historyBack);
    utils.animate.zoomIn();
    this.props.clearHistoryBack();
  }

  /*excludedCAP() {
    let gState = utils.getState()
    let excluded = false;
    if (cap == "26841" || cap == "26823" || cap == "26845") {
      excluded = true;
    }
    return excluded;
  }*/

  /*componentDidUpdate() {
        if(this.state.isOpen === true) {
            window.$('html,body').animate({
                scrollTop: (window.$(".toggle-container").offset().top + window.$(".toggle-container").height() / 2) - 300
            })
        }
    }*/

  triggerFaFunnelEvent(product) {
    switch (product) {
      case 1:
        handleFaFunnel('Prestito personale');
        break;
      case 3:
        handleFaFunnel('Cessione del quinto');
        // skipScegliLuogo();
        // skipDataAppuntamento();
        break;
      case 4:
        handleFaFunnel('Carta di credito');
        break;
      case 5:
        handleFaFunnel('Prestito business');
        skipScegliLuogo();
        skipDataAppuntamento();
        break;
    }
  }

  editAppointment(editType = "") {
    const { appuntamento_recuperato: appuntamento } = this.state;

    if (appuntamento) {
      const { utente, oppID, prodotto, luogo, coordinate_luogo: coordinateLuogo, data_appuntamento: dataAppuntamento, orario_appuntamento: orarioAppuntamento, filiale, id_filiale: idFiliale, indirizzoFiliale } = appuntamento;
      
      if (utente) {
        this.props.setDatiPersonali({
          nome: utente.nome,
          cognome: utente.cognome,
          email: utente.email,
          telefono: utente.telefono,
          cap:
            utente.cap && utente.cap != ""
              ? utente.cap
              : "99999",
          impiego: utente.impiego
        });
      }

      if (oppID) {
        this.props.setVecchioAppuntamento(appuntamento);
        this.props.setOppID(oppID);
        this.props.setFlussoModifica(true);
        
        switch (editType) {
          case 'modifica':
            this.props.setModificando(true);
            break;
          case 'annulla':
            this.props.setRecap(true);
            this.props.setProdotto(prodotto);
            this.props.setDove({
              luogo: luogo,
              coordinate_luogo: coordinateLuogo
            });
            this.props.setGiorno(utils.setDateFormat(dataAppuntamento));
            this.props.setOrario(orarioAppuntamento);
            this.props.setFiliale({
              id: utils.padLeft3(idFiliale),
              nome: filiale,
              indirizzo: indirizzoFiliale
            });
            //Imposto fake i consensi per farlo passare
            this.props.setConsensi({
              informativa: true,
              dati_personali: true,
              societa_terze: true
            });
            break;
        }
      } else {
        if (utente.nome) {
          //Se non ho l'appuntamento ma ho i dati personali, mando al recap
          this.props.setRecap(false);
        } else {
          // da controllare
          this.props.setRecap(true);
        }
      }
    } else {
      this.props.setRecap(true);
    }

    handleFlow();
  }

  // setDatiAppuntamento(action) {
  //   let appuntamento = this.state.appuntamento_recuperato;

  //   if (appuntamento.oppID) {
  //     this.props.setVecchioAppuntamento(appuntamento);
  //     this.props.setOppID(appuntamento.oppID);
  //     this.props.setDatiPersonali({
  //       nome: appuntamento.utente.nome,
  //       cognome: appuntamento.utente.cognome,
  //       email: appuntamento.utente.email,
  //       telefono: appuntamento.utente.telefono,
  //       cap:
  //         appuntamento.utente.cap && appuntamento.utente.cap != ""
  //           ? appuntamento.utente.cap
  //           : "99999",
  //       impiego: appuntamento.utente.impiego
  //     });

  //     if (action == "modifica") {
  //       this.props.setFlussoModifica(true);
  //       this.props.setModificando(true);
  //     } else if (action == "annulla") {
  //       this.props.setFlussoModifica(true); //Imposto il flusso come modifica per essere portato alla typ giusta
  //       this.props.setRecap(true);
  //       this.props.setProdotto(appuntamento.prodotto);
  //       this.props.setDove({
  //         luogo: appuntamento.luogo,
  //         coordinate_luogo: appuntamento.coordinate_luogo
  //       });
  //       this.props.setGiorno(utils.setDateFormat(appuntamento.data_appuntamento));
  //       this.props.setOrario(appuntamento.orario_appuntamento);
  //       this.props.setFiliale({
  //         id: utils.padLeft3(appuntamento.id_filiale),
  //         nome: appuntamento.filiale,
  //         indirizzo: appuntamento.indirizzoFiliale
  //       });
  //       this.props.setVecchioAppuntamento(appuntamento);
  //       this.props.setOppID(appuntamento.oppID);
        
  //       if (appuntamento.utente) {
  //         this.props.setDatiPersonali({
  //           nome: appuntamento.utente.nome,
  //           cognome: appuntamento.utente.cognome,
  //           email: appuntamento.utente.email,
  //           telefono: appuntamento.utente.telefono,
  //           cap:
  //             appuntamento.utente.cap && appuntamento.utente.cap != ""
  //               ? appuntamento.utente.cap
  //               : "99999",
  //           impiego: appuntamento.utente.impiego
  //         });
  //         //Imposto fake i consensi per farlo passare
  //         this.props.setConsensi({
  //           informativa: true,
  //           dati_personali: true,
  //           societa_terze: true
  //         });
  //       }
  //     }
  //   } else {
  //     if (appuntamento.utente.nome) {
  //       //Se non ho l'appuntamento ma ho i dati personali, mando al recap
  //       this.props.setRecap(false);
  //       this.props.setDatiPersonali({
  //         nome: appuntamento.utente.nome,
  //         cognome: appuntamento.utente.cognome,
  //         email: appuntamento.utente.email,
  //         telefono: appuntamento.utente.telefono,
  //         cap:
  //           appuntamento.utente.cap && appuntamento.utente.cap != ""
  //             ? appuntamento.utente.cap
  //             : "99999",
  //         impiego: appuntamento.utente.impiego
  //       });
  //     } else {
  //       this.props.setRecap(true);
  //     }
  //   }

  //   handleFlow();
  // }

  processCfInfo(data, cf) {
    let self = this;
    let res_body = data;
    //res_body = mockedUserRiconosciuto; //Mock di test
    let globalState = utils.getState();
    const haUnAppuntamentoFissatoSuC5 = (globalState.prodotto == 3 && res_body.appuntamento && res_body.appuntamento.tipologia && res_body.appuntamento.tipologia != "");
    if (globalState.prodotto != 5 && (res_body.ac || res_body.suggestC5 || haUnAppuntamentoFissatoSuC5) && res_body.utente && res_body.utente.email) {
      trackRedirection('redirect');
      self.props.setFoundDbCompass(true);

      /*
       * Rimosso il 2022-05-31, Dicono che era solo un test
          //Redirigo al nuovo fissa appuntamento
          utils.redirectToFa3(cf);
          return false;
      */

      //Già cliente, lo porto su flusso PP
      if (res_body.appuntamento && res_body.appuntamento.oppID) { //Ho già un appuntamento
        //Apro la modal per la scelta di modifica
        self.setState({
          popup_open: true
        });
      } else { //Non ho un appuntamento, deve rifare le scelte
        let userDataExists = false;
        
        self.props.setFlowSwitch({
          goToNextStepAutomatically: false,
          previousFlow: globalState.prodotto,
        });

        if (res_body.appuntamento && res_body.appuntamento.utente) {
          const { utente } = res_body.appuntamento;

          const cap = utente.cap || "99999";

          if (utente.nome && utente.cognome && utente.email && utente.telefono && cap && utente.impiego) {
            self.props.setDatiPersonali({
              nome: utente.nome,
              cognome: utente.cognome,
              email: utente.email,
              telefono: utente.telefono,
              cap: cap,
              impiego: utente.impiego
            });

            userDataExists = true;
          }
        }

        switchToPrestitoPersonale({
          disableRedirect: false,
          userDataExists,
        });
      }
    } else if (globalState.prodotto == 3 && res_body.appuntamento && res_body.appuntamento.oppID) { // Sono su flusso C5 e ho già appuntamento
      self.setState({
        popup_open: true,
      });
    } else {
      //Non è cliente, va sul normale flusso C5
      if (!res_body.appuntamento || !res_body.appuntamento.utente || !res_body.appuntamento.utente.cognome) {
        self.props.setRecap(true);
      } else {
        if (res_body.appuntamento && res_body.appuntamento.utente) {
          const { utente } = res_body.appuntamento;

          const cap = utente.cap || "99999";

          if (utente.nome && utente.cognome && utente.email && utente.telefono && cap && utente.impiego) {
            self.props.setDatiPersonali({
              nome: utente.nome,
              cognome: utente.cognome,
              email: utente.email,
              telefono: utente.telefono,
              cap: cap,
              impiego: utente.impiego
            });
          }
        }
      }
      handleFlow();
    }
  }
  async getFiliali() {
    return new Promise(function (resolve) {
      const state = utils.getState();
      const luogo = state.luogo;
      const cap = luogo.match(/\d{5}/)[0];
      const payload = {
        "Coordinate": {
          "lat": state.coordinate_luogo.lat,
          "lng": state.coordinate_luogo.lng
        },
        "Cap": cap,
        "TipoFiliali": 1
      }
      apiInvoker.TrovaFiliali(payload , res => {
        if (res.status == 200) {
          resolve(res.data);
        } else {
          resolve(null)
        }
      })
    });
  }
  handleSubmit = event => {
    event.preventDefault();

    let self = this;

    if (validateForm(event.target)) {
      //Se tutti i campi del form sono validi
      const cf = event.target.codice_fiscale.value;
      this.props.setCF(cf);
      trackCF(cf);
      self.setState({
        loading: true
      });
      if (utils.getState().prodotto == 3 || utils.getState().prodotto == 5/* || self.excludedCAP()*/) {
        
        apiInvoker.CheckCFC5(cf, res => {
          self.setState({
            loading: false
          });
          if (res.status == 200) {
            const { data: responseBody } = res;
            let { appuntamento } = responseBody;

            if (appuntamento && appuntamento.utente && appuntamento.utente.email) {
              appuntamento.utente = utils.getFinalUserData(appuntamento.utente);
            }
            
            self.setState({
              appuntamento_recuperato: appuntamento,
            });

            self.processCfInfo(responseBody, cf);
          }
        }, err => {
            self.processCfInfo(null);
        })
      } else {
        let gState = utils.getState();
        let flusso = 'prestito_personale';

        if (gState.prodotto == 4) {
          flusso = 'carta_di_credito'
        }

        apiInvoker.CheckByCF(
          cf,
          flusso,
          async (res) => {
            self.setState({
              loading: false,
            });

            if (res.status == 200) {
              const { data: responseBody } = res;
              let { trackingUrl, suggestC5, appuntamento } = responseBody;

              if (responseBody.status == 200) {
                const redirectToC5 = responseBody.app || responseBody.APP || false;
                /*
                 * è un ex cliente C5, lo rimando sul flusso C5 e deve 
                 * riscegliere una filiale C5 in sostituzione a quella Compass
                 */
                if (redirectToC5) {
                  self.props.setProdotto(3);
                  self.props.setGiorno("");
                  self.props.setRecap(true);
                  const nuoveFiliali = await self.getFiliali();
                  self.props.setFiliali({
                    "filiali": nuoveFiliali
                  });
                  handleFlow();
                  return false;
                }
                if (trackingUrl) {
                  axios.get(trackingUrl);
                }

                if (responseBody.hasOwnProperty('ricontatto') && responseBody.ricontatto == true) {
                  self.props.setRicontattoCf(responseBody.ricontatto);
                }
                
                if (suggestC5) {
                  //Trovato nelle liste Compass
                  trackRedirection("email");
                  self.props.setFoundDbCompass(true);
                }

                //I clienti a cui manca almeno un dato devono inserirli tutti
                if (
                  appuntamento
                  && appuntamento.utente
                  && (
                    (!appuntamento.utente.nome || appuntamento.utente.nome == "")
                    || (!appuntamento.utente.cognome || appuntamento.utente.cognome == "")
                    || (!appuntamento.utente.email || appuntamento.utente.email == "")
                    || (!appuntamento.utente.telefono || appuntamento.utente.telefono == "")
                    || ((!appuntamento.utente.cap || appuntamento.utente.cap == "") && appuntamento.tipologia != "Agenzia/PV C5")
                    )
                  ) {
                  appuntamento.utente = {
                    nome: "",
                    cognome: "",
                    email: "",
                    telefono: "",
                    cap: ""
                  }
                }

                self.setState({
                  appuntamento_recuperato: appuntamento,
                });
        
                //Non ha un appuntamento fissato
                if (!appuntamento.oppID) {
                  self.editAppointment();
                } else {
                  //Apro la modal per la scelta
                  self.setState({
                    popup_open: true,
                  });
        
                  // In qualsiasi caso in cui il CF non è riconosciuto traccio la visita della pagina
                  // trackPageView('codice-fiscale');
                }
              } else if (responseBody.status == 400) {
                document.querySelector(".modal-error .error-text").innerText =
                  responseBody.message;
                document
                  .querySelector(".modal-error-container")
                  .classList.add("is-modal-shown");
              }
            }
          },
          (err) => {
            this.setState({
              loading: false,
            });

            document.querySelector(".modal-error .error-text").innerText = err;
            document
              .querySelector(".modal-error-container")
              .classList.add("is-modal-shown");
          }
        );
      }
    } else {
      self.setState({ errors: "Codice fiscale non valido" });
    }
  };

  handleModifica() {
    // this.setState({
    //   scelto_modifica: true
    // });
    // this.props.setRecap(true);
    // this.setDatiAppuntamento("modifica");
    // this.setDatiAppuntamento("annulla");

    const reduxState = utils.getState();
    console.log('handleModifica: ', reduxState.prodotto);
    
    this.editAppointment("annulla");
  }

  handleAnnulla() {
    goToHomepage();
  }

  handleToggle = () => {
    if (!this.state.isOpen) {
      this.setState({ isOpen: true });
    }
  };

  render() {
    const { prodotto, excluded } = this.props;
    let recapAreaVisibility = true;;

    if (prodotto == -2 || excluded) {
      recapAreaVisibility = false;
    }

    return (
      <div>
        <Stepper percentage="70" />
        <ModalError />
        <ModalBoxModifica
          visible={this.state.popup_open}
          handler={this.handleModifica}
          handler2={this.handleAnnulla}
        />{" "}
        <Spinner visible={this.state.loading} />{" "}
        <div className="grid-container" id="codice_fiscale">
          <RecapArea visible={recapAreaVisibility} />
          <div className="grid-x grid-padding-x">
            <div className="cell animations-container">
              <ToggleContainer
                title={utils.getState().prodotto == 5 ? (<Fragment>Codice fiscale <span className="text--secondary-color">del legale rappresentante</span></Fragment>) : 'Il tuo codice fiscale'}
                type="codice fiscale"
                isOpen={this.state.isOpen}
                handleToggle={this.handleToggle}
                handleSubmit={this.handleSubmit}
                updateCode={this.updateCode}
                errors={this.state.errors}
              />{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>
    );
  }
}

function validateForm(form) {
  const cf = form.codice_fiscale.value;
  let valid_cf = utils.validateCF(cf);
  return valid_cf;
}

export default connect(mapStateToProps, mapDispatchToProps)(CodiceFiscale);



// WEBPACK FOOTER //
// ./src/components/codice_fiscale/index.js